

import axios from "axios";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import InfluencerHeader from "./InfluencerHeader";
import Navbar from "./Navbar";

const Productspost = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

 const fetchProducts = async () => {
  setLoading(true);
  const minimumLoadingTime = 3000; // 3 secondssssssssssssssssss
  const startTime = Date.now();

  try {
    const res = await axios.get("https://server-side-influencer.onrender.com/influencer/product/all");
    setProducts(res.data);
  } catch (error) {
    console.error("Error fetching products:", error);
  } finally {
    const elapsed = Date.now() - startTime;
    const waitTime = minimumLoadingTime - elapsed;

    if (waitTime > 0) {
      setTimeout(() => setLoading(false), waitTime);
    } else {
      setLoading(false);
    }
  }
};


  useEffect(() => {
    fetchProducts();
  }, []);

  // Number of skeleton cards to show during loading
  const skeletonCount = 6;

  return (
    <div className="flex h-screen" style={{ marginLeft: '72px' }}>
      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <InfluencerHeader page="Products" />
      </div>
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      <div className="flex-1 p-6 mt-12" style={{ marginLeft: '3px' }}>
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6 mt-10">
       Exclusive Instagram Product Collections🛍️
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {loading
            ? Array.from({ length: skeletonCount }).map((_, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-2xl shadow-md overflow-hidden transition duration-300 hover:shadow-xl p-4"
                >
                  <Skeleton height={192} className="mb-2" /> {/* Image skeleton */}
                  <Skeleton height={20} width={`80%`} className="mb-1" /> {/* Title */}
                  <Skeleton height={15} width={`60%`} className="mb-3" /> {/* Caption */}
                  <Skeleton height={15} width={100} /> {/* Link */}
                </div>
              ))
            : products.map((product) => (
                <div
                  key={product._id}
                  className="bg-white rounded-2xl shadow-md overflow-hidden transition duration-300 hover:shadow-xl"
                >
                  <img
                    src={product.image}
                    alt={product.customTitle || "Product Image"}
                    className="w-full h-48 object-fit-cover"
                  />
                
                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-900">
                      {product.customTitle || "No Title"}
                    </h3>
     {/* Original Product Title */}
                    <p className="text-sm text-gray-600 italic mt-0.5">
                      {product.originalTitle || "No Product Title"}
                    </p>
                      <p className="text-sm text-gray-600 mt-2 truncate px-4">
                    {product.caption || "No caption"}
                  </p>
                    <a
                      href={product.shareableLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block mt-3 text-blue-600 hover:underline text-sm"
                    >
                      Visit Link
                    </a>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default Productspost;
